import Header from '@/layout/components/header.vue';
export default {
  name: 'Index',
  components: {
    Header
  },
  data() {
    return {
      hiddenGlobalNav: false
    };
  },
  mounted() {
    this.hiddenGlobalNav = sessionStorage.getItem('hiddenGlobalNav');
  },
  methods: {
    backtopHover() {
      // this.right = 18
    },
    backtopBlur() {
      // this.right = -21
    }
  }
};